import PropTypes from 'prop-types';
import { Navigate, useMatch } from 'react-router-dom';

import { ErrorBoundary } from '@zenbusiness/application-commons-logging';
import PageError from '@zenbusiness/zui/PageError';
import PageLoading from '@zenbusiness/zui/PageLoading';

import { DEFAULT_SEGMENT, NAME } from '#client/build-env';
import { ROUTE_ACCESS_POLICIES } from '#client/constants/routeAccessPolicies';
import { useAccountExperience } from '#client/hooks/useAccountExperience';
import { useDashboardPath } from '#client/hooks/useDashboardPath';

function CustomerRouteGuardInner({ children }) {
  const { accountExperience, loading } = useAccountExperience();
  const isAtEntityIndex = useMatch(`${DEFAULT_SEGMENT}/:businessEntityUuid`);
  const dashboardPath = useDashboardPath();

  if (loading) {
    return <PageLoading />;
  }

  if (accountExperience.routing.accessPolicy === ROUTE_ACCESS_POLICIES.HOME_ONLY && !isAtEntityIndex) {
    return <Navigate to={dashboardPath} replace />;
  }

  return children;
}

CustomerRouteGuardInner.propTypes = {
  children: PropTypes.node.isRequired,
};

export default function CustomerRouteGuard({ children }) {
  return (
    <ErrorBoundary fallback={<PageError />} id={`${NAME}/App/CustomerRouteGuard`}>
      <CustomerRouteGuardInner>{children}</CustomerRouteGuardInner>
    </ErrorBoundary>
  );
}

CustomerRouteGuard.propTypes = {
  children: PropTypes.node.isRequired,
};
